(() => {
  const targetHandle = '/products/homelex-pirate-head-scarf-sash-belt-set-halloween-bandana-waist-accessories-cosplay-costume';
  const moveOverlay = () => {
    const cards = [...document.querySelectorAll('.product-card-wrapper')];
    const targetCard = cards.find((card) => card.querySelector(`a[href^="${targetHandle}"]`));
    if (!targetCard) return;
    const targetMedia = targetCard.querySelector('.card__media');
    if (!targetMedia || targetMedia.querySelector('.homelex-anniversary-overlay')) return;
    const existing = document.querySelector('.homelex-anniversary-overlay');
    if (existing) targetMedia.prepend(existing);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(moveOverlay));
  else requestAnimationFrame(moveOverlay);
})();
